import { atom } from "recoil"

export const alertState = atom({
    key: "alert-display",
    default: { type: "none", message: "" },
})

export const firebaseAlertState = atom({
    key: "firebase-alert-display",
    default: { type: "none", message: "" },
})